import React from 'react';

/** This context can be used by components that compose ActionList inside a Menu */

const ActionListContainerContext = /*#__PURE__*/React.createContext({});

export { ActionListContainerContext };
